import { useState, useRef, useEffect } from "react";

export const useOpenState = (openSetter: (open: boolean) => void) => {
  const [open, setOpen] = useState(false);

  const ref = useRef(null);
  const openSetterRef = useRef(openSetter);

  useEffect(() => {
    openSetterRef.current = openSetter;
  }, [openSetter]);

  const handleOpen = () => {
    setOpen((open) => {
      const newState = !open;
      if (openSetterRef.current) {
        openSetterRef.current(newState);
      }
      return newState;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const currentRef = ref?.current as unknown as HTMLDivElement;

      if (currentRef && !currentRef.contains(event.target as Node)) {
        setOpen(false);
        if (openSetterRef.current) {
          openSetterRef.current(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return {
    open,
    setOpen: handleOpen,
    ref,
  };
};
